import { useMutation } from '@tanstack/react-query';

import { useSnackbar } from 'notistack';

import { EventReportApprovalRequest, FlightEventClient, FlightEventReportDTO, ProblemDetails } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const flightEventClient = new FlightEventClient(apiBaseUrl);
function useSendNotification() {
  const { enqueueSnackbar } = useSnackbar();
  return useMutation<FlightEventReportDTO, ProblemDetails, EventReportApprovalRequest>({
    mutationKey: [queryKeys.FlightEvent.ReNotify],
    mutationFn: (request: EventReportApprovalRequest) => flightEventClient.reNotify(request),
    onError: (error) => {
      const statusMessage = error.status === 409
        ? 'Form data has changed on the server, please refresh the page and try again.'
        : 'An unexpected error has occurred.';

      enqueueSnackbar(statusMessage, { variant: 'error', persist: true });
    },
    onSuccess: () => {
      enqueueSnackbar('Notification sent', { variant: 'success' });
    },
  });
}

export default useSendNotification;
